exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-max[data-v-721a0257]{max-height:calc(100vh - 100px);overflow:scroll}.tips[data-v-721a0257]{color:#999}.upLoadPicBox .upLoad[data-v-721a0257],.upLoadPicBox .pictrue[data-v-721a0257]{width:80px;height:80px}.sort-img[data-v-721a0257]{display:-webkit-box;display:-ms-flexbox;display:flex}", ""]);

// exports
